/**
 * WebRTC API configuration constants
 */

// WebRTC connection states
export const CONNECTION_STATES = {
  IDLE: 'idle',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  ERROR: 'error'
};

// Maximum reconnection attempts
export const MAX_RECONNECT_ATTEMPTS = 3;

// Reconnection delay in milliseconds
export const RECONNECT_DELAY = 2000;

// Mock SIP domain for development
export const MOCK_SIP_DOMAIN = 'mock.dasha.ai';